module.exports = __webpack_public_path__ + "static/gain-services-f30af9ab4a02c8053167ae080c4cf56c.jpg";